import { Content, Section, SectionTitle, Title, Wrapper } from "./style";

export const AboutComponent = () => {
  return (
    <Wrapper>
      <Title>О компании</Title>

      <Section>
        <SectionTitle>Коротко о нас</SectionTitle>

        <Content>
          ООО «Biletonline» организовано в августе 2019, является онлайн-трэвел агентством по продаже авиабилетов
          по территории Узбекистана, за пределы Республики Узбекистан и по другим направлениям.
        </Content>

        <Content>
          Aviabozor.uz – глобальная онлайн-платформа, собравшая в одном интерфейсе многих востребованных поставщиков
          авиационного контента, более 200 авиакомпаний Узбекистана, России и других перевозчиков мира.
        </Content>

        <Content>
          ООО «Biletonline» подписаны прямые договора с авиакомпаниями Узбекистана — с ГАВС «Uzbekistan Airways»,
          ООО «Qanot Sharq», Centrum Air, Fly Khiva, Silk Avia, Fly One Asia и Air Samarkand.
        </Content>

        <Content>
          Наша компания имеет договорные отношения с агрегаторами и консолидаторами авиационного контента Узбекистана
          (Don Avia Trans, Easy Booking и Avia Centre Asia) и России (Мой Агент и Аэро-Тур).
        </Content>
      </Section>

      <Section>
        <SectionTitle>Подключённые партнёры</SectionTitle>

        <Content>
          К нашей онлайн-платформе Aviabozor.uz от наших компаний-партнеров подключены:
        </Content>

        <Content>
          — NDC AEROFLOT, SIBERIA AIRLINES, URAL AIRLINES, TURKISH AIRLINES, FLYDUBAI;
        </Content>

        <Content>
          — Web-service (Mixvel, Amadeus, AccelAero, Hitit, Sabre) по «прямым» договорам авиа-контента наших партнеров:
          POBEDA, RED WINGS, AZIMUT, NORD WIND, AZERBAIJAN HAVA YOLLARY, AIR ARABIA, QATAR AIRWAYS, AIR ASTANA,
          FLY ARYSTAN, AIRCOMPANY SCAT, AVIA TRAFFIC COMPANY, AIR COMPANY TEZ JET, SOMON AIR, FLY ONE,
          FLYONE ARMENIA, LOT — POLISH AIRLINES и других Авиакомпаний;
        </Content>

        <Content>
          — Billing and Settlement Plan (BSP) RU, DE, ES, KZ;
        </Content>

        <Content>
          — Контент перевозчиков Китая (AIR CHINA LIMITED, CHINA SOUTHERN AIRLINES, CHINA EASTERN AIRLINES,
          HAINAN AIRLINES, SHENZHEN AIRLINES, CHINA UNITED AIRLINES, CHANGAN AIRLINES, JUNEYAO AIRLINES,
          BEIJING CAPITAL AIRLINES, HEBEI AIRLINES, ZHEJIANG LOONG AIRLINES, DONGHAI AIRLINES), в том числе
          внутри КНР по самым низким ценам, с уникальными стыковками из разных систем бронирования и инвенторов,
          в том числе лоукостеров, специальные и конфиденциальные тарифы.
        </Content>
      </Section>

      <Section>
        <SectionTitle>Участник ТКП и BSP</SectionTitle>

        <Content>
          ООО «Biletonline» — участник Системы взаиморасчетов на воздушном транспорте, код аккредитации в
          АО «ТКП» – 06ТАС.
        </Content>

        <Content>
          38 авиакомпаний России, 28 перевозчиков стран СНГ, Ближнего Востока, Африки и Юго-Восточной Азии
          являются участниками Системы взаиморасчетов на воздушном транспорте.
        </Content>
      </Section>

      <Section>
        <SectionTitle>Наши специалисты</SectionTitle>

        <Content>
          В компании работают специалисты, имеющие опыт работы с основными системами бронирования,
          представленными на рынке Узбекистана — АРС Сирена-Трэвел, GDS Amadeus, CRS Hitit, CRS Avtra,
          CRS Online Reservation System и B2B-платформ Авиакомпаний и агрегаторов (консолидаторов).
        </Content>
      </Section>

      <Section>
        <SectionTitle>Платёжные системы</SectionTitle>

        <Content>
          Сайт Aviabozor.uz подключён к национальным платёжным системам UzCard и HumoCard, которые сертифицированы
          по международным стандартам безопасности, а также международных платежных систем (Visa, Master Card).
        </Content>

        <Content>
          В настоящий момент ведем работы по подключению платежной системы МИР.
        </Content>

        <Content>
          Оплачивать за авиабилеты и услуги, купленные на нашем сайте, можно через приложения Uzum, PayNet,
          PayMe и Click.
        </Content>
      </Section>

      <Section>
        <SectionTitle>Туристическая деятельность</SectionTitle>

        <Content>
          Также наша компания занимается выездным и въездным туризмом из стран Европы и Азии в Республику
          Узбекистан. (Лицензия на туристическую деятельность №420048, выдана Комитетом по туризму Управления
          туризма города Ташкента, выдана 30.09.2024 г. бессрочно).
        </Content>
      </Section>
    </Wrapper>
  );
};
